import { siteStats } from "@/mocks/creators";

const methods = [
  {
    icon: "ri-eye-line",
    title: "公开素材并置",
    desc: "只取博主本人公开发布的内容，按时间顺位排列，不做任何画面处理。",
  },
  {
    icon: "ri-scales-3-line",
    title: "四维对比口径",
    desc: "从造型、妆容成熟度、镜头表现力、后期程度四个维度给出相对评分。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续追踪更新",
    desc: "已收录对象会跟随后续公开露面补进时间线，不做一次性快照。",
  },
];

export default function StatsSection() {
  return (
    <section className="w-full bg-foreground-950">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
          <div>
            <p className="text-xs tracking-[0.24em] text-accent-400">METHOD</p>
            <h2 className="mt-3 font-heading text-2xl font-black text-background-50 md:text-3xl">
              我们怎么整理这些对比
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-300">
              对比这件事很容易变成情绪化围观，所以我们给自己定了三条规矩，让内容尽量回到"记录变化"本身。
            </p>

            <dl className="mt-8 grid grid-cols-2 gap-6">
              {siteStats.map((item) => (
                <div key={item.label}>
                  <dt className="text-xs text-foreground-400">{item.label}</dt>
                  <dd className="mt-1 font-heading text-2xl font-black text-accent-400 md:text-3xl">
                    {item.value}
                    <span className="ml-1 text-sm font-normal text-foreground-400">
                      {item.suffix}
                    </span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <ul className="flex flex-col gap-4">
            {methods.map((method) => (
              <li
                key={method.title}
                className="flex gap-4 rounded-lg border border-foreground-800 bg-foreground-900 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className={`${method.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-background-50">
                    {method.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-300">{method.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}